import React from "react";
import { Anchor, Coffee, Sofa, Eye, Waves, Users } from "lucide-react";
import { BOAT_FEATURES, IMG } from "@/data/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const ICONS = [Anchor, Coffee, Sofa, Eye, Waves, Users];

export default function Boat() {
  return (
    <section className="relative bg-brand-navy py-24 md:py-32" data-testid="boat-section">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl shadow-2xl shadow-black/40">
              <img
                src={IMG.boat}
                alt="Caravela Ana Clara — embarcação da Dive Master navegando pela Costa Esmeralda"
                className="aspect-[16/11] w-full object-cover"
                data-testid="boat-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 to-transparent" />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <Overline className="text-sun">A bordo</Overline>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.04] tracking-tight text-white sm:text-5xl">
              Embarcação confortável e espaçosa
            </h2>
            <p className="mt-5 text-base leading-relaxed text-white/75">
              Enquanto espera seu mergulho, você pode entrar na água usando máscara,
              snorkel e roupa de neoprene. Poucas pessoas por saída para uma
              experiência tranquila e exclusiva.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {BOAT_FEATURES.map((f, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <div
                    key={f}
                    className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 backdrop-blur-md"
                  >
                    <Icon className="h-5 w-5 shrink-0 text-ocean-glow" />
                    <span className="text-sm font-medium text-white">{f}</span>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
